import { render, staticRenderFns } from "./MetaAdsetForm.vue?vue&type=template&id=f38adda8"
import script from "./MetaAdsetForm.vue?vue&type=script&lang=js"
export * from "./MetaAdsetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports